// extracted by mini-css-extract-plugin
export default {"container":"w2bTIX","mainBlock":"OeSH2U","bannerText":"o5wUSs","link":"E4Dtrn","closeButton":"XbmcSq","searchFadeIn":"isKGpJ"};